import { get, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { realTimeDB } from "../firebase";
import PostLiveVideoContent from "./PostLiveVideoContent";

const PostLiveVideos = () => {
    const [postlivevideos,setPostlivevideos]=useState([]);

    useEffect(()=>{
        async function fetchPostLivevideos() {
            const videosSnapshot = await get(ref(realTimeDB,"postLive"));
            if (videosSnapshot.exists()) {
                const videosSubdata = videosSnapshot.val();
                const videosChildArray = Object.keys(videosSubdata).map((key) =>({
                    id: key,
                    ...videosSubdata[key]
                }));
                setPostlivevideos(videosChildArray.reverse())
            }
        }
        fetchPostLivevideos();
    },[]);



    return ( 
        <div className="postlivevideos">
            {postlivevideos && postlivevideos.map(data =>(
                <PostLiveVideoContent
                key={data.id}
                url={data.url}
                utcTime={data.utcTime}
                liveDesc={data.liveDesc}
                />
            ))}
            </div>
     );
}
export default PostLiveVideos;